import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StyleManager {
    // isDark = false;
    private darkTheme = new BehaviorSubject<boolean>(this.loadDarkTheme());
    isDarkTheme = this.darkTheme.asObservable();

    loadDarkTheme(): boolean {
        const darkThemeExists = localStorage.getItem('dark-theme');
        const darkTheme = 'dark-theme';

        if (darkThemeExists) {
            const href = 'dark-theme.css';
            document.body.classList.add(darkTheme);
            getLinkElementForKey(darkTheme).setAttribute('href', href);
            return true;
        }
        return false;
    }

    setDarkTheme(isDarkTheme: boolean): void {
        const darkTheme = 'dark-theme';
        const body = document.body;

        if (isDarkTheme) {
            const href = 'dark-theme.css';
            localStorage.setItem(darkTheme, JSON.stringify(isDarkTheme));
            getLinkElementForKey(darkTheme).setAttribute('href', href);
            body.classList.add(darkTheme);
        }
        else {
            localStorage.removeItem(darkTheme);
            this.removeStyle(darkTheme);
            body.classList.remove(darkTheme);
        }

        this.darkTheme.next(isDarkTheme);
    }

    // toggleDarkTheme() {
    //     if (this.isDark) {
    //         this.removeStyle('dark-theme');
    //         document.body.classList.remove('dark-theme');
    //         this.isDark = false;
    //     } else {
    //         const href = 'dark-theme.css';
    //         getLinkElementForKey('dark-theme').setAttribute('href', href);
    //         document.body.classList.add('dark-theme');
    //         this.isDark = true;
    //     }
    // }

    removeStyle(key: string) {
        const existingLinkElement = getExistingLinkElementByKey(key);
        if (existingLinkElement) {
            document.head.removeChild(existingLinkElement);
        }
    }
}

function getLinkElementForKey(key: string) {
    return getExistingLinkElementByKey(key) || createLinkElementWithKey(key);
}

function getExistingLinkElementByKey(key: string) {
    return document.head.querySelector(
        `link[rel="stylesheet"].${getClassNameForKey(key)}`
    );
}

function createLinkElementWithKey(key: string) {
    const linkEl = document.createElement('link');
    linkEl.setAttribute('rel', 'stylesheet');
    linkEl.classList.add(getClassNameForKey(key));
    document.head.appendChild(linkEl);
    return linkEl;
}

function getClassNameForKey(key: string) {
    return `style-manager-${key}`;
}
